import fetch from "auth/FetchInterceptor";

const staffService = {};

staffService.GetStaffSSR = async function (data) {
  return fetch({
    url: "/Account/GetAllSSR",
    method: "post",
    data: data,
  });
};
staffService.CreateStaff = async function (data) {
  return fetch({
    url: "/Account/Create",
    method: "post",
    data: data,
  });
};
staffService.GetStaffById = async function (params) {
  return fetch({
    url: "/Account/GetById",
    method: "get",
    params,
  });
};
staffService.UpdateStaff = async function (data) {
  return fetch({
    url: "/Account/Update",
    method: "post",
    data: data,
  });
};

staffService.GetRoles = async function () {
  return fetch({
    url: "/Account/GetStaffRoles",
    method: "get",
  });
};
staffService.SetActive = async function (params) {
  return fetch({
    url: "/Account/SetIsActive",
    method: "get",
    params,
  });
};
staffService.GetAllStaff = async function () {
  return fetch({
    url: "/Account/GetAll",
    method: "Get",
  });
};
staffService.GetTechnicalAssessment = async function () {
  return fetch({
    url: "/Account/GetTechnicalAssessment",
    method: "Get",
  });
};
staffService.GetHRAssessment = async function () {
  return fetch({
    url: "/Account/GetHRAssessment",
    method: "Get",
  });
};
export default staffService;
